import Vue from 'vue'
import Router from 'vue-router'
import {routes} from '@/router/routes'
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  // mode: 'history',
  routes: routes
})
// router.beforeEach((to, from, next) => {
//   routeInterupter(to, from, next)
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js